/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { useGetEnvironmentOrgUnitsQuery } from "~/generated/graphql";

type Props = {
  id: string;
};

export function useEnvironmentBusinessContexts({ id }: Props) {
  const { data, loading, error } = useGetEnvironmentOrgUnitsQuery({
    variables: {
      id,
    },
  });

  const businessContexts = React.useMemo(
    () =>
      data?.environment?.orgUnitsV2?.orgUnits?.map(({ businessContext }) => ({
        value: businessContext.id,
        label: businessContext.name,
        isPrimary: businessContext.isPrimary,
      })) ?? [],
    [data]
  );

  return {
    businessContexts,
    loading,
    error,
  };
}
